import React, { useContext, useEffect, useState } from 'react'
import css from "./signup.module.scss"
import { Input } from "../../componentsV1/Input"
import { AuthContext } from "../../context/auth.js"
import { CountryDropdown, StateDropdown } from '../../components/DropDowns/index.js'
import { Checkbox } from '../../componentsV1/Checkbox/index.jsx'
import { checkEmailExist, getCustomerGroupsApi, createCustomerApi, createCustomerGroupApi, verifyCustomerApi, updateCustomerApi, addCustomerAddressesApi, loginApi } from '../../api/index.js'
import { countryCode } from '../../utils/country.js'
import { setLocalStorage } from '../../helpers/localStorage.js'
import Logo from "../../assets/v1/logo.png"

export const SignUp = () => {
  const { signUpModal, setSignUpModal, setSignInModal, setCompleteModal, setIsLoading, setNotification, login, user, isLoggedIn } = useContext(AuthContext)
  const [current, setCurrent] = useState(0)
  const [types, setTypes] = useState([])
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [position, setPosition] = useState('')
  const [email, setEmail] = useState('')
  const [country, setCountry] = useState('United States');
  const [academic, setAcademic] = useState()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [validPassword, setValidPassword] = useState(false)
  const [error, setError] = useState(false)
  const [code, setCode] = useState('')
  const [taxExempt, setTaxExempt] = useState(false)
  const [taxExemptNumber, setTaxExemptNumber] = useState('')
  const [shippingAddress, setShippingAddress] = useState({
    first_name: '',
    last_name: "",
    company: '',
    address_1: '',
    city: '',
    province: '',
    country_code: '',
    postal_code: '',
    metadata: {
      department: '',
      building: '',
      lab: '',
      attention_to: '',
      type: "shipping",
      is_primary: true
    }
  })
  const [asShipping, setAsShipping] = useState(false)
  const [billingAddress, setBillingAddress] = useState({
    first_name: '',
    last_name: "",
    company: '',
    address_1: '',
    city: '',
    province: '',
    country_code: '',
    postal_code: '',
    metadata: {
      department: '',
      building: '',
      lab: '',
      attention_to: '',
      type: "billing",
      is_primary: true
    }
  })

  useEffect(() => {
    if (signUpModal && !user) {
      setCurrent(0)
      fetchCustomerGroups()
    }else if (user && signUpModal){
      if(!user?.customer?.metadata?.is_email_verified){
        setCurrent(2)
        setEmail(user?.customer?.email)
        resendEmail()
      }
      else if(user?.customer?.is_tax_exempt === null ){
        setCurrent(3)
      }
      else if (!user?.customer?.shipping_addresses?.length){
        setCurrent(4)
      }else if (!user?.customer?.billing_address){
        setCurrent(5)
      }
    }
  }, [signUpModal, user])

  const fetchCustomerGroups = () => {
    setIsLoading(true)
    getCustomerGroupsApi().then((res) => {
      if (res?.data?.customerGroups) {
        setTypes(res?.data?.customerGroups)
        setIsLoading(false)
      }
    })
  }

  const signUp = () => {
    setIsLoading(true)
    if (password.length < 8 || !/[A-Z]/.test(password) || !/\d/.test(password) || !confirmPassword) {
      setError('Password must be at least 8 characters long, contain at least one uppercase letter, and one number')
      setIsLoading(false)
    }
    else if (password !== confirmPassword) {
      setError('Password does not match')
      setIsLoading(false)
    } else {
      if(types.find((group) => group.name === academic)){
        createCustomerApi({
          email,
          isSignUp: true,
          firstName,
          lastName,
          password,
          group_id: types.find((group) => group.name === academic)?.id,
          position,
          country
        }).then((res) => {
          setIsLoading(false)
          setNotification({
            type: 'success',
            message: 'Verification code has been sent to your email address!'
          })
          setError('')
          setCurrent(2)
          loginApi({
            email,
            password
          }).then((res) => {
            if (res?.data?.access_token) {
              setLocalStorage('identifyntoken', res?.data?.access_token)
              // login(res.data)
            }
          }) 
        }).catch(() => {
          setIsLoading(false)
          setNotification({
            type: 'red',
            message: 'Something went wrong, please try again!'
          })
          setError('')
        }) 
      }else{
        createCustomerGroupApi({
          name: academic
        }).then((res) => {
          if(res && res.data){
            createCustomerApi({
              email,
              isSignUp: true,
              firstName,
              lastName,
              password,
              group_id: res?.data?.id,
              position,
              country
            }).then((res) => {
              setIsLoading(false)
              setNotification({
                type: 'success',
                message: 'Verification code has been sent to your email address!'
              })
              setError('')
              setCurrent(2)
              loginApi({
                email,
                password
              }).then((res) => {
                if (res?.data?.access_token) {
                  setLocalStorage('identifyntoken', res?.data?.access_token)
                  // login(res.data)
                }
              }) 
            }).catch(() => {
              setIsLoading(false)
              setNotification({
                type: 'red',
                message: 'Something went wrong, please try again!'
              })
              setError('')
            }) 
          }else{
            setIsLoading(false)
            setNotification({
              type: 'red',
              message: 'Something went wrong, please try again!'
            })
            setError('')
          }
        })
      }
    }
  }

  const verify = () => {
    setIsLoading(true)
    verifyCustomerApi(encodeURIComponent(email), code).then((res) => {
      if(res.message){
        setNotification({
          type: 'red',
          message: res.message.message
        })

      }else{
        setNotification({
          type: 'email',
          message: 'Email verified!'
        })
        setCurrent(3)
        login(res.data)
      }
      setIsLoading(false)
    }).catch((err) => {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Invalid verification code!'
      })
    })
  }

  const updateTaxExempt = () => {
    setIsLoading(true)
    updateCustomerApi({
      is_tax_exempt: taxExempt,
      tax_number: taxExemptNumber
    }).then((res) => {
      if(res.data){
        setIsLoading(false)
        setNotification({
          type: 'success',
          message: 'Tax exempt updated!'
        })
        setCurrent(4)
        login(res.data)
      }else{
        setIsLoading(false)
        setNotification({
          type: 'red',
          message: 'Something went wrong, please try again!'
        })
      }
    }).catch((err) => {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Something went wrong, please try again!'
      })
    })
  }

  const addShippingAddress = () => {
    const data = {
      ...shippingAddress,
      country_code: countryCode[shippingAddress.country_code]
    }
    setIsLoading(true)
    addCustomerAddressesApi({
      address: data
    }).then((res) => {
      if (res.data) {
        setNotification({
          type: 'success',
          message: 'Address updated successfully'
        })
        setIsLoading(false)
        login(res.data)
        setCurrent(5)
      } else {
        setNotification({
          type: 'red',
          message: 'Something went wrong'
        })
        setIsLoading(false)
      }
    }).catch((err) => {
      setNotification({
        type: 'red',
        message: 'Something went wrong'
      })
      setIsLoading(false)
    })
  }

  const addBillingAddress = () => {
    const data = asShipping ? {
      ...shippingAddress,
      country_code: countryCode[shippingAddress.country_code],
      metadata:{
        ...shippingAddress.metadata,
        type:"billing"
      }
    }
      : {
        ...billingAddress,
        country_code: countryCode[billingAddress.country_code]
      }
    setIsLoading(true)
    addCustomerAddressesApi({
      address: data
    }).then((res) => {
      if (res.data) {
        updateCustomerApi({
          billing_address: data
        }).then((res) => {
          if (res.data) {
            setNotification({
              type: 'success',
              message: 'Address updated successfully'
            })
            login(res.data)
            setSignUpModal(false)
            setCompleteModal(true)
            setIsLoading(false)
          } else {
            setNotification({
              type: 'red',
              message: 'Something went wrong'
            })
            setIsLoading(false)
          }
        })
      } else {
        setNotification({
          type: 'red',
          message: 'Something went wrong'
        })
        setIsLoading(false)
      }
    }).catch((err) => {
      setNotification({
        type: 'red',
        message: 'Something went wrong'
      })
      setIsLoading(false)
    })
  }


  const resendEmail = () => {
    setIsLoading(true)
    createCustomerApi({
      email:user?.customer?.email ? user?.customer?.email : email,
      isSignUp: true
    }).then((res) => {
      setIsLoading(false)
      setNotification({
        type: 'success',
        message: 'Verification code has been sent to your email address!'
      })
    }).catch(() => {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Something went wrong, please try again!'
      })
    })
  }

  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
        <i className={`fal fa-times ${css.closeIcon}`} onClick={() => {
          setSignUpModal(false)
        }}></i>
        <div className={css.leftContainer}>
          {current <= 2 && <div className="steps">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "19px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "var(--blueColor)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current > 0 ? "var(--blueColor)" : current === 0 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
              <div
                style={{
                  height: "1px",
                  width: "200px",
                  margin:' 0 5px',
                  backgroundColor: current >= 1 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                }}
                className="progress-connector-line"
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: current >= 1 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current > 1 ? "var(--blueColor)" : current === 1 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
              <div
                style={{
                  height: "1px",
                  width: "200px",
                  margin:' 0 5px',
                  backgroundColor: current >= 2 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                }}
                className="progress-connector-line"
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: current >= 2 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current >= 2 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
            </div>
          </div>}
          {current >= 3 && <div className="steps">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "19px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "var(--blueColor)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current > 3 ? "var(--blueColor)" : current === 3 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
              <div
                style={{
                  height: "1px",
                  width: "200px",
                  margin:' 0 5px',
                  backgroundColor: current >= 4 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                }}
                className="progress-connector-line"
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: current >= 4 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current > 4 ? "var(--blueColor)" : current === 4 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
              <div
                style={{
                  height: "1px",
                  width: "200px",
                  margin:' 0 5px',
                  backgroundColor: current >= 5 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                }}
                className="progress-connector-line"
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: current >= 5 ? "var(--blueColor)" : "rgba(154, 154, 154, 0.2)",
                  color: "#ffffff",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "1px solid transparent",
                }}
              >
                <span
                  style={{
                    background: current >= 5 ? "#fcfcfc" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></span>
              </div>
            </div>
          </div>}
          {current === 0 && <div className={css.firstStep}>
            <div>
              <h1>Welcome to IDENTiFYN®</h1>
              <p>Please complete account sign up.</p>
            </div>
            <div className={css.column}>
              <div className={css.twoRow}>
                <Input className={"First"} required label={'First Name'} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                <Input required label={"Last Name"} className={"Last"} value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
              <div className={css.twoRow}>
                <Input placeholder="Position *" value={position} onChange={(e) => setPosition(e.target.value)} />
                <Input placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <CountryDropdown value={country} onChange={(e) => setCountry(e)} />
              <div className={css.twoRow}>
                <div className={css.selectOption} style={{ background: academic === 'Academic' ? '#F5F5F51A' : 'inherit' }}>
                  <label class={css.containers}>
                    <input type="radio" name="academic" value="Academic" onChange={(e) => setAcademic(e.target.value)} checked={academic === 'Academic'} />
                    <span class={css.checkmark}></span>
                    <span>Academic</span>
                  </label>
                </div>
                <div className={css.selectOption} style={{ background: academic === 'Industry' ? '#F5F5F51A' : 'inherit' }}>
                  <label class={css.containers}>
                    <input type="radio" name="academic" value="Industry" onChange={(e) => setAcademic(e.target.value)} checked={academic === 'Industry'} />
                    <span class={css.checkmark}></span>
                    <span>Industry</span>
                  </label>
                </div>
              </div>
            </div>
            <button className={`btn ${css.ctaBtn}`} disabled={!firstName || !lastName || !position || !email || !country || !academic} onClick={() => {
             if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)){
               setCurrent(1)
             }else{
              setNotification({
                type:'red',
                message:'Please enter a valid Email Address',
              })
             }
            }}>Create Account</button>
            <p className={css.centerText}>Already have an Account? <button className={css.link} onClick={() => {
              setSignUpModal(false)
              setSignInModal(true)
            }}>Sign In</button></p>
            <small className={`${css.centerText} ${css.smallText}`}>By clicking the “Create Account” button, by using the website, or by proceeding with the purchase of products or services, you accept and agree to be bound by: (1) the identifyn.com Terms of Use ; and (2) the applicable terms and conditions of sale for the products and services you purchase on identifyn.com</small>
          </div>
          }
          {current === 1 && <div className={css.secondStep}>
            <div>
              <h1>Create Password</h1>
              <p>Please create a password, it will be used for the next sign-ins.</p>
            </div>
            <div className={css.column}>
              <div className={css.inputWrapper}>
                <div className={css.label}>
                <p>Create Password <span>*</span></p>
                </div>
                <Input type='password' placeholder={"Password"} value={password} onChange={(e) => setPassword(e.target.value)} className={error ? 'error' : ''} />
              </div>
              <div className={css.inputWrapper}>
                <div className={css.label}>
                  <p>Confirm Password <span>*</span></p>
                  {error && error === 'Password does not match' && <p><span>Passwords must match</span></p>}
                </div>
                <Input type='password' placeholder={"Confirm Password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={error ? 'error' : ''} />
              </div>
            <div className={css.passwordValidations}>
              <span style={{ color: '#fff' }}>{password.length >= 8 ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#fff', marginRight: '8px' }}></i>}At least 8 characters</span>
              <span style={{ color: '#fff' }}>{/[A-Z]/.test(password) ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#fff', marginRight: '8px' }}></i>}At least 1 upper case letter (A-Z).</span>
              <span style={{ color: '#fff' }}>{/\d/.test(password) ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#fff', marginRight: '8px' }}></i>}At least 1 number (0-9).</span>
            </div>
            </div>
            <div className={css.buttonContainer}>
              {error && error !== 'Password does not match' && <p style={{ color: '#DC1E00', opacity: '1', fontSize: '16px', textAlign: 'center' }}>{error}</p>}
              <button className={`btn ${css.ctaBtn}`} disabled={!password || !confirmPassword} onClick={() => signUp()}>Continue</button>
              <p className={css.centerText}>Aready have an Account? <button className={css.link} onClick={() => {
                setSignUpModal(false)
                setSignInModal(true)
              }}>Sign In</button></p>
            </div>
          </div>
          }
          {current === 2 && <div className={css.secondStep}>
            <div>
              <h1>Verify Your Email Address</h1>
              <p>A verification code was sent to <span style={{color: 'var(--blueColor)'}}>{user?.customer?.email ? user?.customer?.email : email}</span>. This code will be valid for 10 minutes</p>
            </div>
            <div className={css.column}>
              <div className={css.inputWrapper}>
                <h4 className={css.label}>Enter Code Below</h4>
                <Input placeholder="XXXX" value={code} onChange={(e) => setCode(e.target.value)} />
              </div>
            <div>
            <p>If you dont see the email in a few minutes, please try the following:</p>
            <ul style={{marginLeft:'25px'}}>
              <li style={{color:'#fff'}}>Add no-reply@identifyn.com to your Whitelist or Safe Sender List</li>
              <li style={{color:'#fff'}}>Check your junk mail or spam folder</li>
            </ul>
            </div>
            </div>
            <div className={css.buttonContainer}>
              <button className={`btn ${css.ctaBtn}`} disabled={!code} onClick={() => {
                verify()
              }}>Verify</button>
              <p className={css.centerText}>Didn't get a code? <button className={css.link} onClick={() => resendEmail()}>Resend</button></p>
            {!isLoggedIn &&  <p className={css.centerText}>Aready have an Account? <button className={css.link} onClick={() => {
                setSignUpModal(false)
                setSignInModal(true)
              }}>Sign In</button></p>
            }
            </div>
          </div>
          }
          {current === 3 && <div className={css.thirdStep}>
            <div>
              <h1>Finish Registering Your Account</h1>
              <p>Please complete account registration</p>
            </div>
            <div className={css.column}>
              <div className={css.inputWrapper}>
                <h4>Is Your Organization Tax Exempt?</h4>
                <div className={css.twoRow}>
                  <div className={`${css.selectOption} ${taxExempt  ? `${css.selectActive}` : ''}`}>
                    <label class={css.containers}>
                      <input type="radio" name="tax" value={true} onChange={(e) => setTaxExempt(true)} checked={taxExempt} />
                      <span class={css.checkmark}></span>
                      <span>Yes</span>
                    </label>
                  </div>
                  <div className={`${css.selectOption} ${!taxExempt && taxExempt !== null ? `${css.selectActive}` : ''}`}>
                    <label class={css.containers}>
                      <input type="radio" name="tax" value={false} onChange={(e) => setTaxExempt(false)} checked={!taxExempt} />
                      <span class={css.checkmark}></span>
                      <span>No</span>
                    </label>
                  </div>
                </div>
                {taxExempt && <Input placeholder="Tax Exempt Number" value={taxExemptNumber} onChange={(e) => setTaxExemptNumber(e.target.value)} />}
              </div>
            </div>
            <div className={css.buttonContainer}>
              <button className={`btn ${css.ctaBtn}`} disabled={taxExempt && !taxExemptNumber} onClick={() => {
                updateTaxExempt()
              }}>Continue Shipping</button>
              <p className={css.centerText} onClick={() => setSignUpModal(false)}><button className={css.link}>Finish Later</button></p>
            </div>
          </div>
          }
          {current === 4 && <div className={css.fourthStep}>
            <div>
              <h1>Complete Your Account</h1>
            </div>
            <div className="form-container">
              <div className={css.column}>
                <h3>Shipping Address</h3>
                <div className={css.twoRow}>
                  <Input placeholder="First and Last Name *" value={shippingAddress.first_name} onChange={(e) => setShippingAddress({ ...shippingAddress, first_name: e.target.value })} />
                  <Input placeholder="Your Company/Institution *" value={shippingAddress.company} onChange={(e) => setShippingAddress({ ...shippingAddress, company: e.target.value })} />
                </div>
                <div className={css.twoRow}>
                  <Input placeholder="Department *" value={shippingAddress.metadata?.department} onChange={(e) => setShippingAddress({ ...shippingAddress, metadata: { ...shippingAddress.metadata, department: e.target.value } })} />
                  <Input placeholder="Street Address *" value={shippingAddress.address_1} onChange={(e) => setShippingAddress({ ...shippingAddress, address_1: e.target.value })} />
                </div>
                <div className={css.threeRow}>
                  <Input placeholder="Building" value={shippingAddress.metadata?.building} onChange={(e) => setShippingAddress({ ...shippingAddress, metadata: { ...shippingAddress.metadata, building: e.target.value } })} />
                  <Input placeholder="Lab" value={shippingAddress.metadata?.lab} onChange={(e) => setShippingAddress({ ...shippingAddress, metadata: { ...shippingAddress.metadata, lab: e.target.value } })} />
                  <Input placeholder="Attention To" value={shippingAddress.metadata?.attention_to} onChange={(e) => setShippingAddress({ ...shippingAddress, metadata: { ...shippingAddress.metadata, attention_to: e.target.value } })} />
                </div>
                <div className={css.twoRow}>
                  <CountryDropdown value={shippingAddress.country_code} onChange={(e) => setShippingAddress({ ...shippingAddress, country_code: e })} />
                  <StateDropdown country={shippingAddress.country_code} placeholder={"Select State"} value={shippingAddress.province} onChange={(e) => setShippingAddress({ ...shippingAddress, province: e })} />
                </div>
                <div className={css.twoRow}>
                  <Input placeholder="Select City *" value={shippingAddress.city} onChange={(e) => setShippingAddress({ ...shippingAddress, city: e.target.value })} />
                  <Input placeholder="Zip Code *" value={shippingAddress.postal_code} onChange={(e) => setShippingAddress({ ...shippingAddress, postal_code: e.target.value })} />
                </div>
              </div>
            </div>
            <div className={css.buttonContainer}>
              <button className={`btn ${css.ctaBtn}`} 
               disabled={!shippingAddress.first_name || !shippingAddress.company || !shippingAddress.address_1 || !shippingAddress.city || !shippingAddress.postal_code || !shippingAddress.country_code || !shippingAddress.province || !shippingAddress.metadata.department}
              onClick={() => addShippingAddress()}>Continue to Billing</button>
              <p className={css.centerText}><button className={css.link} onClick={() => setCurrent(3)}>Back to Tax Exempt</button></p>
            </div>
          </div>
          }
          {current === 5 && <div className={css.fourthStep}>
            <div>
              <h1>Complete Your Account</h1>
            </div>
            <div className="form-container">
              <div className={css.column}>
                <div className={css.label}>
                  <h3>Billing Address</h3>
                  <Checkbox label="Same as Shipping" checked={asShipping} onChange={() => setAsShipping(!asShipping)} />
                </div>
                {!asShipping && <>
                  <div className={css.twoRow}>
                    <Input placeholder="First and Last Name *" value={billingAddress.first_name} onChange={(e) => setBillingAddress({ ...billingAddress, first_name: e.target.value })} />
                    <Input placeholder="Your Company/Institution *" value={billingAddress.company} onChange={(e) => setBillingAddress({ ...billingAddress, company: e.target.value })} />
                  </div>
                  <div className={css.twoRow}>
                    <Input placeholder="Department *" value={billingAddress.metadata?.department} onChange={(e) => setBillingAddress({ ...billingAddress, metadata: { ...billingAddress.metadata, department: e.target.value } })} />
                    <Input placeholder="Street Address *" value={billingAddress.address_1} onChange={(e) => setBillingAddress({ ...billingAddress, address_1: e.target.value })} />
                  </div>
                  <div className={css.threeRow}>
                    <Input placeholder="Building" value={billingAddress.metadata?.building} onChange={(e) => setBillingAddress({ ...billingAddress, metadata: { ...billingAddress.metadata, building: e.target.value } })} />
                    <Input placeholder="Lab" value={billingAddress.metadata?.lab} onChange={(e) => setBillingAddress({ ...billingAddress, metadata: { ...billingAddress.metadata, lab: e.target.value } })} />
                    <Input placeholder="Attention To *" value={billingAddress.metadata?.attention_to} onChange={(e) => setBillingAddress({ ...billingAddress, metadata: { ...billingAddress.metadata, attention_to: e.target.value } })} />
                  </div>
                  <div className={css.twoRow}>
                    <CountryDropdown value={billingAddress.country_code} onChange={(e) => setBillingAddress({ ...billingAddress, country_code: e })} />
                    <StateDropdown country={billingAddress.country_code} placeholder={"Select State"} value={billingAddress.province} onChange={(e) => setBillingAddress({ ...billingAddress, province: e })} />
                  </div>
                  <div className={css.twoRow}>
                    <Input placeholder="Select City *" value={billingAddress.city} onChange={(e) => setBillingAddress({ ...billingAddress, city: e.target.value })} />
                    <Input placeholder="Zip Code *" value={billingAddress.postal_code} onChange={(e) => setBillingAddress({ ...billingAddress, postal_code: e.target.value })} />
                  </div>
                </>
                }
              </div>
            </div>
            <div className={css.buttonContainer}>
              <button className={`btn ${css.ctaBtn}`}
                disabled={!asShipping && (!billingAddress.first_name || !billingAddress.company || !billingAddress.address_1 || !billingAddress.city || !billingAddress.postal_code || !billingAddress.country_code || !billingAddress.province || !billingAddress.metadata.department)}
                onClick={() => {
                  addBillingAddress()
                }}>Complete Registration</button>
              <p className={css.centerText}><button className={css.link} onClick={() => setCurrent(4)}>Back to Shipping</button></p>
            </div>
          </div>
          }
        </div>
        <div className={css.rightContainer}>
          <img src={Logo} alt="logo" />
        </div>
      </div>
    </div>
  )
}